const initialState = {
  suppliers: [],
  editSupplierLoading: false,
}

const supplierReducer = (state = initialState, action) => {
  switch (action.type) {
    case `SET_SUPPLIERS`:
      return {
        ...state,
        suppliers: action.data,
      }
    case `SET_EDIT_SUPPLIER_LOADING`:
      return {
        ...state,
        editSupplierLoading: action.data,
      }
    default:
      return state
  }
}

export default supplierReducer
